var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"botaoScrollTop",on:{"click":_vm.ScrollTopoApp}},[_c('div',{staticClass:"setaBotaoSrollTop"},[_vm._v("❮")])])}
var staticRenderFns = []

export { render, staticRenderFns }